import React from "react";
import StackedBarChartTestPerYear from "../components/StackedBarChartTestPerYear/StackedBarChartTestPerYear";

export default function StackedBarChartPage() {
  return (
    <React.Fragment>
      <StackedBarChartTestPerYear />
    </React.Fragment>
  );
}
